import { HttpClient } from '@angular/common/http';

import { Component, OnInit } from '@angular/core';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { ActivatedRoute, Router } from '@angular/router';

import { AccountService } from 'src/app/services/account.service';

import { OtherService } from 'src/app/services/other.service';

@Component({

  selector: 'app-guide-pages',

  templateUrl: './guide-pages.component.html',

  styleUrls: ['./guide-pages.component.css'],

})

export class GuidePagesComponent implements OnInit {

  htmlContent: any;

  constructor(
    private http: HttpClient,
    private router: Router,
    private accountService: AccountService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private _Other: OtherService
  ) { }

  getSafeHtml(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  ngOnInit(): void {

    this.route.url.subscribe((segment) => {

      const router = segment[0].path;

      if (router === 'about') {

        this.fetchHTMLFile(1);

        this._Other.setTitle('درباره امدادران | امداد خودرو و جرثقیل سیار')

      }

      if (router === 'general') {

        this.fetchHTMLFile(2);

        this._Other.setTitle('قوانین و مقررات | امداد خودرو و جرثقیل سیار')

      }

      if (router === 'drivers') {

        this._Other.setTitle('عضویت در امدادران |امداد خودرو و جرثقیل سیار')

        this.fetchHTMLFile(3);
      }

      if (router === 'privacy') {
        this.fetchHTMLFile(4);
      }

      if (router === 'contact-us') {
        this.fetchHTMLFile(5);
      }

      if (router === 'emdadran') {

        this._Other.setTitle('امدادران | راحت ترین راه سفر')

        this.fetchHTMLFile(6);

      }

    });

  }

  ngOnDestroy() {

    this._Other.setTitle('');


  }

  fetchHTMLFile(mode) {

    if (mode == 1) {
      this.http
        .get('../../../assets/basic/about.html', { responseType: 'text' })
        .subscribe((data) => {
          this.htmlContent = data;
        });
    }

    if (mode == 2) {
      this.http
        .get('../../../assets/basic/general.html', {
          responseType: 'text',
        })
        .subscribe((data) => {
          this.htmlContent = data;
        });
    }

    if (mode == 3) {
      this.http
        .get('../../../assets/basic/drivers.html', {
          responseType: 'text',
        })
        .subscribe((data) => {
          this.htmlContent = data;
        });
    }

    if (mode == 4) {
      this.http
        .get('../../../assets/basic/privacy.html', {
          responseType: 'text',
        })
        .subscribe((data) => {
          this.htmlContent = data;
        });
    }

    if (mode == 5) {
      this.http
        .get('../../../assets/basic/contactus.html', {
          responseType: 'text',
        })
        .subscribe((data) => {
          this.htmlContent = data;
        });
    }

    if (mode == 6) {

      this.http.get('../../../assets/basic/intercity-taxi.html', {

        responseType: 'text',

      }).subscribe((data) => {

        this.htmlContent = data;

      });
    }

  }

}
